import { Grid } from "@mui/material";
import { useStyles } from "../login/Login.page.style";

const WelcomeTitle = (props) => {
	const classes = useStyles();
	return (
		<Grid item>
			<div className={classes.welcomeFont}>Welcome to EHP</div>
			<div className={classes.welcomeFont}>
				Data Collaboration Laboratory Portal {process.env.REACT_APP_ENV_DESC || ""}
			</div>
		</Grid>
	);
};

export default WelcomeTitle;
